import { PropsWithChildren, FC } from 'react';
import styles from './index.module.scss';

export const Title: FC<PropsWithChildren> = ({ children }) => {
  return <span className={styles.title}>{children}</span>;
};
